/* tslint:disable */
import {
  Payee
} from '../index';

declare var Object: any;
export interface PayeeWebChecklistInterface {
  "payee_id": number;
  "merchant_to_review"?: boolean;
  "is_submitted"?: boolean;
  "website_running"?: boolean;
  "website_3D_secure"?: boolean;
  "info_display"?: boolean;
  "commercial_office"?: boolean;
  "sub_merchant"?: boolean;
  "clear_details"?: boolean;
  "total_cost_display"?: boolean;
  "currency_display"?: boolean;
  "email_confirmation"?: boolean;
  "stmt_details_clear"?: boolean;
  "details_on_payment_server"?: boolean;
  "transaction_receipt"?: boolean;
  "receipt_merchant_name"?: boolean;
  "receipt_merchant_website"?: boolean;
  "receipt_transaction_amount"?: boolean;
  "receipt_currency_type"?: boolean;
  "receipt_transaction_date"?: boolean;
  "receipt_cardholder_name"?: boolean;
  "receipt_auth_code"?: boolean;
  "receipt_transaction_desc"?: boolean;
  "receipt_return_policy"?: boolean;
  "website_secure"?: boolean;
  "return_policy"?: boolean;
  "shipping_method"?: boolean;
  "delivery_time"?: boolean;
  "customer_service"?: boolean;
  "customer_profile"?: boolean;
  "tracking_reference"?: boolean;
  "id"?: number;
  payee?: Payee;
  adminChecklist?: any;
}

export class PayeeWebChecklist implements PayeeWebChecklistInterface {
  "payee_id": number;
  "merchant_to_review": boolean;
  "is_submitted": boolean;
  "website_running": boolean;
  "website_3D_secure": boolean;
  "info_display": boolean;
  "commercial_office": boolean;
  "sub_merchant": boolean;
  "clear_details": boolean;
  "total_cost_display": boolean;
  "currency_display": boolean;
  "email_confirmation": boolean;
  "stmt_details_clear": boolean;
  "details_on_payment_server": boolean;
  "transaction_receipt": boolean;
  "receipt_merchant_name": boolean;
  "receipt_merchant_website": boolean;
  "receipt_transaction_amount": boolean;
  "receipt_currency_type": boolean;
  "receipt_transaction_date": boolean;
  "receipt_cardholder_name": boolean;
  "receipt_auth_code": boolean;
  "receipt_transaction_desc": boolean;
  "receipt_return_policy": boolean;
  "website_secure": boolean;
  "return_policy": boolean;
  "shipping_method": boolean;
  "delivery_time": boolean;
  "customer_service": boolean;
  "customer_profile": boolean;
  "tracking_reference": boolean;
  "id": number;
  payee: Payee;
  adminChecklist: any;
  constructor(data?: PayeeWebChecklistInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PayeeWebChecklist`.
   */
  public static getModelName() {
    return "PayeeWebChecklist";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PayeeWebChecklist for dynamic purposes.
  **/
  public static factory(data: PayeeWebChecklistInterface): PayeeWebChecklist{
    return new PayeeWebChecklist(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PayeeWebChecklist',
      plural: 'payeeWebChecklists',
      path: 'payeeWebChecklists',
      idName: 'id',
      properties: {
        "payee_id": {
          name: 'payee_id',
          type: 'number'
        },
        "merchant_to_review": {
          name: 'merchant_to_review',
          type: 'boolean'
        },
        "is_submitted": {
          name: 'is_submitted',
          type: 'boolean'
        },
        "website_running": {
          name: 'website_running',
          type: 'boolean'
        },
        "website_3D_secure": {
          name: 'website_3D_secure',
          type: 'boolean'
        },
        "info_display": {
          name: 'info_display',
          type: 'boolean'
        },
        "commercial_office": {
          name: 'commercial_office',
          type: 'boolean'
        },
        "sub_merchant": {
          name: 'sub_merchant',
          type: 'boolean'
        },
        "clear_details": {
          name: 'clear_details',
          type: 'boolean'
        },
        "total_cost_display": {
          name: 'total_cost_display',
          type: 'boolean'
        },
        "currency_display": {
          name: 'currency_display',
          type: 'boolean'
        },
        "email_confirmation": {
          name: 'email_confirmation',
          type: 'boolean'
        },
        "stmt_details_clear": {
          name: 'stmt_details_clear',
          type: 'boolean'
        },
        "details_on_payment_server": {
          name: 'details_on_payment_server',
          type: 'boolean'
        },
        "transaction_receipt": {
          name: 'transaction_receipt',
          type: 'boolean'
        },
        "receipt_merchant_name": {
          name: 'receipt_merchant_name',
          type: 'boolean'
        },
        "receipt_merchant_website": {
          name: 'receipt_merchant_website',
          type: 'boolean'
        },
        "receipt_transaction_amount": {
          name: 'receipt_transaction_amount',
          type: 'boolean'
        },
        "receipt_currency_type": {
          name: 'receipt_currency_type',
          type: 'boolean'
        },
        "receipt_transaction_date": {
          name: 'receipt_transaction_date',
          type: 'boolean'
        },
        "receipt_cardholder_name": {
          name: 'receipt_cardholder_name',
          type: 'boolean'
        },
        "receipt_auth_code": {
          name: 'receipt_auth_code',
          type: 'boolean'
        },
        "receipt_transaction_desc": {
          name: 'receipt_transaction_desc',
          type: 'boolean'
        },
        "receipt_return_policy": {
          name: 'receipt_return_policy',
          type: 'boolean'
        },
        "website_secure": {
          name: 'website_secure',
          type: 'boolean'
        },
        "return_policy": {
          name: 'return_policy',
          type: 'boolean'
        },
        "shipping_method": {
          name: 'shipping_method',
          type: 'boolean'
        },
        "delivery_time": {
          name: 'delivery_time',
          type: 'boolean'
        },
        "customer_service": {
          name: 'customer_service',
          type: 'boolean'
        },
        "customer_profile": {
          name: 'customer_profile',
          type: 'boolean'
        },
        "tracking_reference": {
          name: 'tracking_reference',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        payee: {
          name: 'payee',
          type: 'Payee',
          model: 'Payee',
          relationType: 'belongsTo',
                  keyFrom: 'payee_id',
          keyTo: 'id'
        },
        adminChecklist: {
          name: 'adminChecklist',
          type: 'any',
          model: '',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'merchant_checklist_id'
        },
      }
    }
  }
}
